import * as React from 'react';

function SvgSkipBackwardBtnFill(props) {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='1em'
			height='1em'
			fill='currentColor'
			className='svg-icon'
			viewBox='0 0 16 16'
			{...props}>
			<path d='M0 12V4a2 2 0 012-2h12a2 2 0 012 2v8a2 2 0 01-2 2H2a2 2 0 01-2-2zm11.21-6.907L8.5 7.028V5.5a.5.5 0 00-.79-.407L5 7.028V5.5a.5.5 0 00-1 0v5a.5.5 0 001 0V8.972l2.71 1.935a.5.5 0 00.79-.407V8.972l2.71 1.935A.5.5 0 0012 10.5v-5a.5.5 0 00-.79-.407z' />
		</svg>
	);
}

export default SvgSkipBackwardBtnFill;
